import { ActionType, Action } from "../action-types";

const initialState:OrderState[] = [];

const orderstateReducer = (state:OrderState[] = initialState, action:Action) => {
    switch (action.type) {
        case ActionType.SET_ORDERSTATE:
            state = action.payload
            return state;
        default:
            return state;
    }
}

export default orderstateReducer;